import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatListItem, MatListItemIcon, MatListItemLine, MatListItemMeta, MatNavList } from '@angular/material/list';
import { MatPaginator } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { ResponseAgreementDto } from 'generated/apex-rest';
import { PageInfoModule } from '../../../../../apex/src/app/components/page-info/page-info.module';
import { TranslateModule } from '../../../../../apex/src/app/components/translate/translate.module';
import { DaterModule } from '../../../../../apex/src/app/pipes/dater/dater.module';
import { HighlightPipeModule } from '../../../../../apex/src/app/pipes/highlight/highlight-pipe.module';

@Component({
  selector: 'portal-agreement-list',
  templateUrl: './portal-agreement-list.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatNavList,
    MatListItem,
    MatListItemIcon,
    MatIcon,
    MatListItemLine,
    MatProgressSpinner,
    RouterLink,
    MatTooltip,
    DaterModule,
    FormsModule,
    HighlightPipeModule,
    MatCheckbox,
    MatFormField,
    MatInput,
    MatListItemMeta,
    MatPaginator,
    PageInfoModule,
  ],
})
export class PortalAgreementListComponent {
  @Input() agreements: ResponseAgreementDto[] = [];
  @Input() loading = false;
  @Input() tenancyId: number;
}
